import React from "react";
import PropTypes from 'prop-types';
import BlankLink from '../elements/BlankLink';
import Instagram from '../elements/icons/social/Instagram';
import Facebook from '../elements/icons/social/Facebook';
import Youtube from '../elements/icons/social/Youtube';
import { socialLinks } from '../../config/app';

export default class SocialLink extends React.PureComponent {
    renderIcon = (icon) => {
        switch (icon) {
            case 'facebook':
                return <Facebook/>;
            case 'instagram':
                return <Instagram/>;
            case 'youtube':
                return <Youtube/>;
            default:
                return false;
        }
    };
    render() {
        let { link, icon } = this.props;

        return (
            <BlankLink link={link} className={'social-link'}>{this.renderIcon(icon)}</BlankLink>
        );
    }
}

SocialLink.propTypes = {
    link: PropTypes.string.isRequired,
    icon: PropTypes.oneOf(Object.keys(socialLinks)),
};
